import { PropsWithChildren } from 'react';

export function SettingsRow({ children }: PropsWithChildren) {
  return (
    <div className="mt-2 grid grid-cols-1 gap-x-4 gap-y-4 border-b border-gray-900/10 pb-5 md:grid-cols-4">
      {children}
    </div>
  );
}
